import { Component, Input, Output, EventEmitter } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'up-down-arrows',
    template: `
<div style="flex:1;"></div>
<icon icon="ARROW_BACK" *ngIf="!hideUp" class="up" [i15]="true" (click)="moveUp.emit()"></icon>
<icon icon="ARROW_BACK" *ngIf="!hideDown" class="down" [i15]="true" (click)="moveDown.emit()"></icon>
<div style="flex:1;"></div>
`,
    styleUrls: ['./up-down-arrows.scss'],
    standalone: true,
    imports: [IconComponent, CommonModule],
})
export class UpDownArrowsComponent {
  @Input() hideUp = false
  @Input() hideDown = false
  @Output() moveUp: EventEmitter<void> = new EventEmitter()
  @Output() moveDown: EventEmitter<void> = new EventEmitter()
}

